"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const buildValidator_1 = __importDefault(require("./buildValidator"));
const buildValueIsBothTypes = (validatorA, validatorB) => {
    const validationFunction = (value, options) => {
        if (!validatorA(value, options)) {
            return false;
        }
        if (!validatorB(value, options)) {
            return false;
        }
        return true;
    };
    return (0, buildValidator_1.default)(`${validatorA.typeName} & ${validatorB.typeName}`, validationFunction);
};
exports.default = buildValueIsBothTypes;
